<template>
  <div>
    <v-container bg fill-height grid-list-md text-xs-center class="pt-5">
      <v-row no-gutters align-center class="pt-5">
        <v-col cols="12">
          <v-card class="justify-center">
            <v-row>
              <v-card-text class="text-center pb-2 mx-4">
                <v-row no-gutters>
                  <v-col>
                    <h4 class="mb-3">
                      Processes running/pending
                      <tooltipProcesses />
                    </h4>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row no-gutters class="my-3">
                  <v-col v-if="pendingProcesses.length !== 0"></v-col>
                  <v-col>
                    <h5>
                      {{ getProcessMessage(pendingProcesses) }} pending.<br />
                      (Total queue size: {{ queueListSize }})
                    </h5>
                  </v-col>
                  <v-col v-if="pendingProcesses.length !== 0">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          @click="cancelPendingProcesses(pendingProcesses)"
                          icon
                          x-small
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="red">cancel</v-icon>
                        </v-btn>
                      </template>
                      <span>Cancel all pending processes</span>
                    </v-tooltip>
                  </v-col>
                </v-row>
                <div v-if="pendingProcesses.length !== 0">
                  <v-row no-gutters>
                    <v-col>Priority</v-col>
                    <v-col>Mission Name</v-col>
                    <v-col>Actions</v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row
                    v-for="pendingProcess in pendingProcesses"
                    :key="pendingProcess.missionId"
                    no-gutters
                    class="mt-3"
                  >
                    <v-col>
                      {{ getPriorityforPendingMission(pendingProcess) }}
                    </v-col>
                    <v-col>
                      {{ getMissionAndModuleName(pendingProcess) }}
                    </v-col>
                    <v-col>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="cancelProcess(pendingProcess)"
                            x-small
                            color="primary"
                            icon
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="red">clear</v-icon>
                          </v-btn>
                        </template>
                        <span>Cancel</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-row>
                  <v-col>
                    <h5>
                      {{ getProcessMessage(runningProcesses) }} running.<br />
                      (Number of process runners available:
                      {{ numberOfSlotsAvailable }} / {{ totalNumberOfSlots }})
                    </h5>
                  </v-col>
                </v-row>
                <div v-if="runningProcesses.length !== 0">
                  <v-row no-gutters>
                    <v-col>Process Status</v-col>
                    <v-col>Mission Name</v-col>
                    <v-col>Actions</v-col>
                  </v-row>
                  <v-divider></v-divider>
                  <v-row
                    v-for="runningProcess in runningProcesses"
                    :key="runningProcess.missionId"
                    no-gutters
                    class="mt-1"
                    align="center"
                    justify="center"
                  >
                    <v-col>
                      <v-progress-circular
                        v-if="missionStatus !== 0 && missionStatus !== 100"
                        :rotate="-90"
                        :size="40"
                        :width="5"
                        :value="missionStatus"
                        color="primary"
                      >
                        {{ missionStatus }}
                      </v-progress-circular>
                      <v-progress-circular
                        v-else
                        :size="40"
                        :width="5"
                        color="primary"
                        indeterminate
                      ></v-progress-circular>
                    </v-col>
                    <v-col>
                      {{ getMissionAndModuleName(runningProcess) }}
                    </v-col>
                    <v-col>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            @click="cancelProcess(runningProcess)"
                            x-small
                            color="primary"
                            icon
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon color="red">clear</v-icon>
                          </v-btn>
                        </template>
                        <span>Cancel</span>
                      </v-tooltip>
                    </v-col>
                  </v-row>
                </div>
                <v-row
                  v-if="
                    runningProcesses.length !== 0 ||
                    pendingProcesses.length !== 0
                  "
                  no-gutters
                >
                  <v-col>
                    <v-btn
                      @click="cancelAllProcesses()"
                      x-small
                      color="red white--text"
                      class="my-4"
                    >
                      Cancel all
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row v-if="errorProcessMessage.length !== 0" no-gutters>
                  <v-col>
                    {{ errorProcessMessage }}
                  </v-col>
                </v-row>
              </v-card-text>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import tooltipProcesses from '../components/Tooltips/TopNavBar/tooltipProcesses.vue'

export default {
  name: 'Processes',

  components: {
    tooltipProcesses
  },

  mounted() {
    this.$root.$emit('set-current-mission', null)
    this.getNumberOfSlotsAvailable()
    this.updateProcesses()
    this.processStatus = setInterval(
      function () {
        if (this.runningProcesses.length !== 0 && this.missionStatus !== 100) {
          this.updateProcessStatus()
          this.updateProcesses()
          this.getNumberOfSlotsAvailable()
        }
      }.bind(this),
      3000
    )
  },

  beforeDestroy() {
    clearInterval(this.processStatus)
    this.processStatus = null
  },

  data() {
    return {
      pendingProcesses: [],
      runningProcesses: [],
      totalNumberOfSlots: null,
      numberOfSlotsAvailable: null,
      queueListSize: null,
      errorProcessMessage: '',
      processStatus: null,
      missionStatus: 0
    }
  },

  computed: {
    ...mapGetters({ currentUser: 'currentUser', missions: 'missions' })
  },

  methods: {
    updateProcesses() {
      this.getPendingProcess()
      this.getRunningProcess()
    },

    getPendingProcess() {
      this.$http
        .get(this.getApiForUser() + 'pendingprocess')
        .then((response) => {
          this.pendingProcesses = response.data
        })
        .catch((error) => {
          this.errorProcessMessage = error
          return this.errorProcessMessage
        })
    },

    getRunningProcess() {
      this.$http
        .get(this.getApiForUser() + 'runningprocess')
        .then((response) => {
          this.runningProcesses = response.data
        })
        .catch((error) => {
          this.errorProcessMessage = error
          return this.errorProcessMessage
        })
    },

    getNumberOfSlotsAvailable() {
      this.$http
        .get('/users/numberofslotsavailable')
        .then((response) => {
          this.totalNumberOfSlots = response.data.totalNumberOfSlots
          this.numberOfSlotsAvailable = response.data.numberOfSlotsAvailable
          this.queueListSize = response.data.queueListSize
        })
        .catch((error) => {
          this.errorProcessMessage = error
          return this.errorProcessMessage
        })
    },

    updateProcessStatus() {
      if (this.missionStatus < 100) {
        this.getProcessStatus()
      }
    },

    getProcessStatus() {
      const process = this.runningProcesses[0]
      this.$http
        .get(
          this.getApiForUser() +
            this.getMissionModuleId(process) +
            '/status/' +
            this.getMissionId(process)
        )
        .then((response) => {
          this.missionStatus = response.data
          if (this.missionStatus === -1) {
            this.missionStatus = 0
          }
          return this.missionStatus
        })
        .catch((error) => {
          this.errorProcessMessage = error
          return this.errorProcessMessage
        })
    },

    cancelProcess(process) {
      this.$http
        .get(
          this.getApiForUser() +
            this.getMissionModuleId(process) +
            '/stop/' +
            this.getMissionId(process)
        )
        .then(() => {
          this.getPendingProcess()
          this.getRunningProcess()
          this.getNumberOfSlotsAvailable()
        })
        .catch((error) => {
          this.errorProcessMessage = error
          return this.errorProcessMessage
        })
    },

    cancelPendingProcesses(processes) {
      processes.forEach((pendingProcess) => this.cancelProcess(pendingProcess))
    },

    cancelAllProcesses() {
      this.runningProcesses.forEach((process) => this.cancelProcess(process))
      this.pendingProcesses.forEach((process) => this.cancelProcess(process))
    },

    getProcessMessage(process) {
      let processMessage = ''
      switch (process.length) {
        case 0:
          processMessage = 'No processes'
          return processMessage
        case 1:
          processMessage = '1 process'
          return processMessage
        default:
          processMessage = `${process.length} processes`
          return processMessage
      }
    },

    getMissionAndModuleName(process) {
      const moduleName = process.moduleId.replace(/([a-z](?=[A-Z]))/g, '$1 ')
      let missionName = ''
      for (let i = 0; i < this.missions.length; i++) {
        if (this.missions[i].id === process.missionId) {
          missionName = this.missions[i].name
        }
      }
      return `${moduleName}: ${missionName}`
    },

    getPriorityforPendingMission(process) {
      const index = this.pendingProcesses.indexOf(process) + 1
      return index
    },

    getApiForUser() {
      return `/users/${this.currentUser.id}/`
    },

    getMissionModuleId(process) {
      return process.moduleId.toLowerCase() + 's'
    },

    getMissionId(process) {
      return process.missionId
    }
  },

  watch: {
    missionStatus: function () {
      if (this.missionStatus === 100) {
        setTimeout(
          function () {
            if (
              this.pendingProcesses.length === 0 &&
              this.runningProcesses.length === 0
            ) {
              clearInterval(this.processStatus)
              this.getNumberOfSlotsAvailable()
              this.processStatus = null
            }
            this.updateProcesses()
            this.getNumberOfSlotsAvailable()
            this.missionStatus = 0
          }.bind(this),
          10000
        )
      }
    }
  }
}
</script>
